export { default } from './SectionInfo';